<div class="w-100 text-center">
  <i class="fa fa-spinner fa-spin fa-3x"></i>
</div>
